export const REPORT_STATUS_CHOICES = [
    { id: 'NEW', name: 'NEW' },
    { id: 'TRIAGE', name: 'TRIAGE' },
    { id: 'IN_REVIEW', name: 'IN_REVIEW' },
    { id: 'ACTIONED', name: 'ACTIONED' },
    { id: 'CLOSED', name: 'CLOSED' },
    { id: 'REOPENED', name: 'REOPENED' },
];

export const REPORT_RISK_CHOICES = [
    { id: 'P0', name: 'P0' },
    { id: 'P1', name: 'P1' },
    { id: 'P2', name: 'P2' },
    { id: 'P3', name: 'P3' },
];

export const REPORT_REASON_CHOICES = [
    { id: 'UNDERAGE_INAPPROPRIATE', name: 'UNDERAGE_INAPPROPRIATE' },
    { id: 'OFFENSIVE_HATE', name: 'OFFENSIVE_HATE' },
    { id: 'OVER_INTIMACY', name: 'OVER_INTIMACY' },
    { id: 'DANGEROUS_TRAINING', name: 'DANGEROUS_TRAINING' },
    { id: 'MEDICAL_MISLEADING', name: 'MEDICAL_MISLEADING' },
    { id: 'PRIVACY_REQUEST', name: 'PRIVACY_REQUEST' },
    { id: 'ILLEGAL_GUIDANCE', name: 'ILLEGAL_GUIDANCE' },
    { id: 'MISINFORMATION', name: 'MISINFORMATION' },
    { id: 'SPAM_HARASS', name: 'SPAM_HARASS' },
    { id: 'OTHER', name: 'OTHER' },
];

export const REPORT_ACTION_CHOICES = [
    { id: 'MARK_VALID', name: 'MARK_VALID' },
    { id: 'MARK_INVALID', name: 'MARK_INVALID' },
    { id: 'ESCALATE', name: 'ESCALATE' },
    { id: 'CLOSE', name: 'CLOSE' },
    { id: 'REOPEN', name: 'REOPEN' },
    { id: 'APPLY_POLICY_FIX', name: 'APPLY_POLICY_FIX' },
    { id: 'REQUEST_MODEL_ROLLBACK', name: 'REQUEST_MODEL_ROLLBACK' },
];

export const REPORT_DECISION_CHOICES = [
    { id: 'CONFIRMED', name: 'CONFIRMED' },
    { id: 'REJECTED', name: 'REJECTED' },
    { id: 'NEED_MORE_INFO', name: 'NEED_MORE_INFO' },
];

export const REPORT_ROOT_CAUSE_CHOICES = [
    { id: 'PROMPT', name: 'PROMPT' },
    { id: 'POLICY', name: 'POLICY' },
    { id: 'CLASSIFIER', name: 'CLASSIFIER' },
    { id: 'MODEL_REGRESSION', name: 'MODEL_REGRESSION' },
    { id: 'TOOL_CALL', name: 'TOOL_CALL' },
    { id: 'UNKNOWN', name: 'UNKNOWN' },
];
